// What the password-reset email link carried, read once when the app loads,
// before the Supabase client consumes the URL (it removes the tokens).
//   valid:   a fresh one-time link (#access_token=…&type=recovery, or ?code=)
//   refused: Supabase refused it (#error=…: already used or expired)
//   none:    /reset-password opened some other way

export type ResetLinkStatus = 'valid' | 'refused' | 'none'

export function readResetLink(url: { hash: string; search: string }): ResetLinkStatus {
  const hash = new URLSearchParams(url.hash.replace(/^#/, ''))
  const query = new URLSearchParams(url.search)
  if (hash.has('error') || hash.has('error_code') || query.has('error')) return 'refused'
  if ((hash.has('access_token') && hash.get('type') === 'recovery') || query.has('code'))
    return 'valid'
  return 'none'
}

/** The status of the link this page was opened with. */
export const landingResetLink: ResetLinkStatus =
  typeof window === 'undefined' ? 'none' : readResetLink(window.location)
